import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DashboardIcon(props: IconProps) {
    return <Icon {...props} iconKey={"dashboard"}/>
}
